import { Controller } from '@hotwired/stimulus'
import flatpickr from "flatpickr"
import ConfirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate'
import { French } from "flatpickr/dist/l10n/fr.js"

export default class extends Controller {
  static targets = ["input"]

  inputTargetConnected (element) {
    const flatpickrOptions = this.#getOptionsFor(element)

    element.flatpickr = flatpickr(element, {
      plugins: [new ConfirmDatePlugin()],
      locale: French,
      allowInput: true,
      altInput: true,
      altFormat: this.#altFormatFor(element),
      ...flatpickrOptions
    })

    // remove minutes selector
    if (flatpickrOptions.enableMinutes === false) {
      const flatpickrTimeElement = element.flatpickr.timeContainer
      const [hoursInputWrapper, minutesInputWrapper] = flatpickrTimeElement.getElementsByClassName('numInputWrapper')
      hoursInputWrapper.style.width = '100%'
      flatpickrTimeElement.querySelector('.flatpickr-time-separator').remove()
      minutesInputWrapper.remove()
    }
  }

  inputTargetDisconnected (element) {
    element.flatpickr.destroy()
  }

  #getOptionsFor (element) {
    if (element.flatpickrOptions) return element.flatpickrOptions

    if ("flatpickrOptions" in element.dataset) {
      element.flatpickrOptions = JSON.parse(element.dataset.flatpickrOptions)
    } else {
      element.flatpickrOptions = {}
    }

    return element.flatpickrOptions
  }

  #altFormatFor (element) {
    if (this.#getOptionsFor(element).enableTime) {
      return "d / m / Y H:i"
    } else {
      return "d / m / Y"
    }
  }
}
